// extracted by mini-css-extract-plugin
export default {"font-renta":"CatalogItem_font-renta__xWRFF","catalogItem":"CatalogItem_catalogItem__b53D+","icon":"CatalogItem_icon__WII9u"};